<div class="feedback-modal card border-0 shadow-sm overflow-hidden bg-white">
  <!-- Cabeçalho -->
  <div
    class="modal-header border-0 position-relative px-4 pt-4 pb-2 pe-5"
    [@enterAnimation]
  >
    <div class="d-flex align-items-center gap-3 min-w-0">
      <div
        class="feedback-icon-wrap rounded-4 d-flex align-items-center justify-content-center flex-shrink-0"
        aria-hidden="true"
      >
        <span class="material-symbols-outlined feedback-icon" aria-hidden="true"
          >rate_review</span
        >
      </div>
      <div class="min-w-0">
        <h2 class="modal-title fs-5 fw-semibold text-title mb-0">
          Formulário de Feedback
        </h2>
        <p class="text-subtitle mb-0 small">
          Sua opinião nos ajuda a evoluir o sistema
        </p>
      </div>
    </div>
    <button
      type="button"
      class="btn btn-position-top"
      aria-label="Sair sem avaliar"
      title="Sair sem avaliar"
      (click)="modal.dismiss('Cross click'); deslogar()"
    >
      <span
        class="material-symbols-outlined icon-close-modal"
        aria-hidden="true"
        >highlight_off</span
      >
    </button>
  </div>

  <div class="modal-body px-4 pt-2 pb-4">
    <!-- Banner informativo -->
    <div
      class="feedback-banner rounded-4 d-flex align-items-start gap-3 mb-4"
      role="alert"
      [@fade]
    >
      <div
        class="feedback-banner-icon rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
        aria-hidden="true"
      >
        <span class="material-symbols-outlined" aria-hidden="true"
          >rocket_launch</span
        >
      </div>
      <div class="min-w-0">
        <p class="fw-semibold text-title mb-1 small">Ajude-nos a melhorar!</p>
        <p class="text-subtitle mb-0 small lh-sm">
          Deixe seu feedback antes de sair. Cada avaliação contribui para uma
          experiência melhor para toda a comunidade escolar.
        </p>
      </div>
    </div>

    <!-- Identificação -->
    <div
      class="rounded-4 border bg-light bg-opacity-50 px-3 py-2 d-flex align-items-center gap-2 mb-4"
    >
      <i
        class="bi bi-person-badge text-icon-secondary flex-shrink-0"
        aria-hidden="true"
      ></i>
      <span class="small text-subtitle mb-0 lh-sm">
        <span class="fw-semibold text-title">CPF:</span>
        <span class="text-break ms-1" id="cpf-display">{{ cpf }}</span>
      </span>
    </div>

    @if (isSmallScreen$ | async; as isSmallScreen) {
      <div class="vstack gap-4">
        <!-- Mensagem -->
        <div class="card border-0 shadow-sm rounded-4 mb-0">
          <div class="card-body p-3 p-md-4">
            <label
              for="mensagem"
              class="form-label fw-semibold mb-2 text-subtitle small d-flex align-items-center gap-2"
            >
              <i
                class="bi bi-chat-left-text text-icon-secondary"
                aria-hidden="true"
              ></i>
              Mensagem
              <span class="text-muted fw-normal">(opcional)</span>
            </label>
            <textarea
              id="mensagem"
              class="form-control feedback-textarea rounded-4"
              rows="5"
              placeholder="Conte-nos o que você mais gosta, o que poderia melhorar ou sugestões para o sistema..."
              [(ngModel)]="mensagemTexto"
              aria-describedby="mensagem-hint"
            ></textarea>
            <p id="mensagem-hint" class="form-text text-subtitle small mb-0 mt-2">
              Compartilhe detalhes que possam nos ajudar a entender sua
              experiência.
            </p>
          </div>
        </div>

        <!-- Avaliação -->
        <div class="card border-0 shadow-sm rounded-4 mb-0">
          <div class="card-body p-3 p-md-4">
            <div
              class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
            >
              <label
                for="nota"
                class="form-label fw-semibold mb-0 text-subtitle small d-flex align-items-center gap-2"
              >
                <i
                  class="bi bi-star-fill text-icon-secondary"
                  aria-hidden="true"
                ></i>
                Nota
                <span class="text-danger" aria-hidden="true">*</span>
              </label>
              <span
                class="feedback-rating-badge rounded-pill px-3 py-1 small fw-semibold"
                [class.feedback-rating-badge--active]="selectedRating > 0"
                aria-live="polite"
              >
                @if (selectedRating > 0) {
                  {{ selectedRating }}/10 — {{ ratingLabel }}
                } @else {
                  Selecione de 1 a 10
                }
              </span>
            </div>

            <div
              class="feedback-rating-track"
              [class.feedback-rating-track--compact]="isSmallScreen.matches"
            >
              <div
                class="feedback-rating-scroll w-100"
                [ngClass]="{ 'pb-2': isSmallScreen.matches }"
              >
                <ngb-rating
                  class="feedback-rating gap-2"
                  [(rate)]="selectedRating"
                  [max]="10"
                  id="nota"
                  aria-label="Nota de 1 a 10"
                >
                  <ng-template let-fill="fill" let-index="index">
                    <button
                      type="button"
                      class="circle-rating"
                      [class.filled]="fill === 100"
                      [class.circle-rating--hoverable]="fill !== 100"
                      [attr.aria-label]="'Nota ' + (index + 1)"
                      (click)="avaliar(index + 1)"
                    >
                      <span class="rating-number">{{ index + 1 }}</span>
                    </button>
                  </ng-template>
                </ngb-rating>
              </div>
              <div class="d-flex justify-content-between mt-2 px-1">
                <span class="feedback-scale-label text-subtitle small">
                  <i class="bi bi-emoji-frown me-1" aria-hidden="true"></i>
                  Insatisfeito
                </span>
                <span class="feedback-scale-label text-subtitle small">
                  Satisfeito
                  <i class="bi bi-emoji-smile ms-1" aria-hidden="true"></i>
                </span>
              </div>
            </div>

            <div class="feedback-confetti-anchor"></div>
          </div>
        </div>

        <!-- Rodapé -->
        <div
          class="feedback-footer rounded-4 p-3 p-md-4"
          [ngClass]="{ 'feedback-footer--stacked': isSmallScreen.matches }"
        >
          <div class="form-check form-switch feedback-switch mb-0">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="lembrar"
              [(ngModel)]="lembrarInput"
              (ngModelChange)="onLembrarChange($event)"
            />
            <label class="form-check-label text-subtitle small" for="lembrar">
              Não perguntar novamente
            </label>
          </div>

          <div
            class="feedback-actions d-flex gap-2"
            [ngClass]="{
              'flex-column': isSmallScreen.matches,
              'flex-row-reverse': !isSmallScreen.matches,
            }"
          >
            <button
              type="button"
              class="btn btn-ergon d-flex gap-2 align-items-center justify-content-center"
              (click)="submitFeedback(); modal.dismiss('Cross click'); deslogar()"
            >
              <span class="material-symbols-outlined" aria-hidden="true"
                >send</span
              >
              Enviar feedback
            </button>
            <button
              type="button"
              class="btn btn-feedback-secondary d-flex gap-2 align-items-center justify-content-center"
              (click)="modal.dismiss('Cross click'); deslogar()"
            >
              <span class="material-symbols-outlined" aria-hidden="true"
                >logout</span
              >
              Sair sem avaliar
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
